// src/analytics.js
import ReactGA from "react-ga4";

const measurementId = "G-X9S73N9M9M";

export const initGA = () => {
    ReactGA.initialize(measurementId);
};

export const logPageView = (path) => {
    ReactGA.send({ hitType: "pageview", page: path });
};
